// import styles from './DateSocialShareBody.module.scss';
import SocialShare from 'govbr.frontend.policy/components/SocialShare';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import ContentDate from '../../ContentDate';

const resolveFirstDefinedValue = (...values) => {
  return values.find(
    (value) => value !== undefined && value !== null && value !== '',
  );
};

const DateSocialShareBody = ({ properties, data = {}, hideTag }) => {
  const { hideDate = false, hideShare = false } = data;
  const token = useSelector((state) => state.userSession?.token);
  const isAuthenticated = Boolean(token);
  const effective = resolveFirstDefinedValue(
    properties?.effective,
    properties?.effective_date,
    properties?.EffectiveDate,
  );
  const shouldHideTag = hideTag || (!isAuthenticated && !effective);

  return (
    <div className="mt-3xh mb-3x">
      <span className="br-divider my-2" />
      <div className="d-flex flex-column flex-wrap align-items-center flex-md-row justify-content-md-between">
        {hideDate ? (
          <span />
        ) : (
          <ContentDate item={properties} hideTag={shouldHideTag} />
        )}
        {hideShare ? null : (
          <SocialShare url={properties?.['@id']} className="mt-3 mt-md-0" />
        )}
      </div>
      <span className="br-divider my-2" />
    </div>
  );
};

DateSocialShareBody.propTypes = {
  properties: PropTypes.shape({
    created: PropTypes.string,
    modified: PropTypes.string,
    effective: PropTypes.string,
    effective_date: PropTypes.string,
    EffectiveDate: PropTypes.string,
  }),
  data: PropTypes.shape({
    hideDate: PropTypes.bool,
    hideShare: PropTypes.bool,
  }),
  hideTag: PropTypes.bool,
};

export default DateSocialShareBody;
